// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CenterLayout_wrapper__2OWVi","inner":"CenterLayout_inner__2w5oJ"};